import { render } from "./NewsShow.vue?vue&type=template&id=3590c0a1"
import script from "./NewsShow.vue?vue&type=script&lang=js"
export * from "./NewsShow.vue?vue&type=script&lang=js"

import "./NewsShow.vue?vue&type=style&index=0&id=3590c0a1&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__